(() => {
  const controllers = new WeakMap();

  function mount(nav) {
    if (controllers.has(nav)) return;
    const items = [...nav.querySelectorAll('[data-thl-mega-item]')];
    let active = null;
    let clickOpened = false;
    let closeTimer = 0;

    function close() {
      clearTimeout(closeTimer);
      if (!active) return;
      const panel = active.querySelector('[data-thl-mega-panel]');
      const trigger = active.querySelector('[data-thl-mega-trigger]');
      active.classList.remove('is-open');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      active = null;
      clickOpened = false;
    }

    function open(item) {
      const panel = item.querySelector('[data-thl-mega-panel]');
      const trigger = item.querySelector('[data-thl-mega-trigger]');
      if (!panel || !trigger) return;
      clearTimeout(closeTimer);
      if (active === item) return;
      close();
      active = item;
      clickOpened = false;
      panel.hidden = false;
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 160);
    }

    function onPointerEnter(event) {
      if (event.pointerType !== 'touch') open(event.currentTarget);
    }

    function onFocusIn(event) {
      const item = event.target.closest('[data-thl-mega-item]');
      if (item && item.querySelector('[data-thl-mega-panel]')) open(item);
      else close();
    }

    function onFocusOut(event) {
      if (!nav.contains(event.relatedTarget)) scheduleClose();
    }

    function onClick(event) {
      const trigger = event.target.closest('[data-thl-mega-trigger]');
      if (!trigger || !nav.contains(trigger)) return;
      const item = trigger.closest('[data-thl-mega-item]');
      if (active === item && clickOpened) close();
      else {
        open(item);
        clickOpened = true;
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape' && active) {
        const trigger = active.querySelector('[data-thl-mega-trigger]');
        trigger?.focus();
        close();
      }
    }

    function onOutside(event) {
      if (!nav.contains(event.target)) close();
    }

    items.forEach(item => {
      item.addEventListener('pointerenter', onPointerEnter);
      item.addEventListener('pointerleave', scheduleClose);
    });
    nav.addEventListener('focusin', onFocusIn);
    nav.addEventListener('focusout', onFocusOut);
    nav.addEventListener('click', onClick);
    nav.addEventListener('keydown', onKeydown);
    document.addEventListener('pointerdown', onOutside);

    controllers.set(nav, () => {
      close();
      items.forEach(item => {
        item.removeEventListener('pointerenter', onPointerEnter);
        item.removeEventListener('pointerleave', scheduleClose);
      });
      nav.removeEventListener('focusin', onFocusIn);
      nav.removeEventListener('focusout', onFocusOut);
      nav.removeEventListener('click', onClick);
      nav.removeEventListener('keydown', onKeydown);
      document.removeEventListener('pointerdown', onOutside);
    });
  }

  function mountAll() {
    document.querySelectorAll('[data-thl-mega]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-thl-mega]').forEach(nav => {
      controllers.get(nav)?.();
      controllers.delete(nav);
    });
  });
})();
